import {Directive, ElementRef, HostListener, inject} from '@angular/core';

@Directive({
    selector: '[appNavDropdown]',
    standalone: false
})
export class NavDropdownDirective {

  private el = inject(ElementRef);

  toggle() {
    this.el.nativeElement.classList.toggle('open');
  }
}

/**
* Allows the dropdown to be toggled via click.
*/
@Directive({
    selector: '[appNavDropdownToggle]',
    standalone: false
})
export class NavDropdownToggleDirective {
  private dropdown = inject(NavDropdownDirective);

  @HostListener('click', ['$event'])
  toggleOpen($event: any) {
    $event.preventDefault();
    this.dropdown.toggle();
  }
}

export const NAV_DROPDOWN_DIRECTIVES = [NavDropdownDirective, NavDropdownToggleDirective];
